import { useState } from 'react'
import { Maximize2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Typography } from '@/components/ui/typography'
import { cn } from '@/lib/utils'
import type { DealLeadDetail } from '@/types/api'
import { FILE_ACTION_CLASSES } from '@/features/deal-review/review-tones'
import { SourceFilePreviewDialog } from '@/components/custom/deal-review/source-files-section'
import { SourceEmail } from '@/components/custom/deal-review/source-email'

// The email-body route rejects attachments, so ORIGINAL_EMAIL is found, not assumed first.
export function SourceEmailTab({ lead }: { lead: DealLeadDetail }) {
  const [reading, setReading] = useState(false)
  const emailFile = lead.sourceFiles.find(
    (file) => file.kind === 'ORIGINAL_EMAIL'
  )

  if (!emailFile) {
    return (
      <Typography variant="body-sm" className="italic text-primary/50">
        No original email was captured with this message.
      </Typography>
    )
  }

  return (
    <div className="flex flex-col gap-3">
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={cn(FILE_ACTION_CLASSES, 'self-end')}
        onClick={() => setReading(true)}
      >
        <Maximize2 aria-hidden="true" />
        Read full email
      </Button>
      <SourceEmail sourceFileId={emailFile.id} />
      <SourceFilePreviewDialog
        file={reading ? emailFile : null}
        onClose={() => setReading(false)}
      />
    </div>
  )
}
